import React from "react";
import PropTypes from "prop-types";
import isNumber from "lodash/isNumber";
import Timer from "./Timer";

const ContainerStyle = {
	width: '100%',
	backgroundColor: '#e44b4b30',
	height: 5,
	borderRadius: 5,
	display: 'flex'
}

const SliderStyle = {
	width: '50%',
	backgroundColor: 'red',
	height: 5,
	borderRadius: 5
}

class ProgressBar extends React.Component {
	constructor(props){
        super(props);
        const { timerData } = this.props;
        this.state = {
        	timeLeftInPercentage: (timerData.timeLeft*100)/timerData.totalTime
        }
        this.timeLeftInSec = 0;
    }

	componentWillMount(){
		const { timerData } = this.props;
		if(timerData) {
			const { timeLeft, totalTime } = timerData;
			this.timeLeftInSec = timeLeft;
            this.timer = setInterval(_=>{
                if(this.timeLeftInSec > 0) {
					this.setState({
						timeLeftInPercentage: (this.timeLeftInSec*100)/totalTime,
					})
                } else {
                    clearInterval(this.timer);
                    this.setState({
                    	timeLeftInPercentage: 0
                    });
                }
            	this.timeLeftInSec -=1;
            },1000);
		}
	}

	componentWillUnmount(){
        clearInterval(this.timer);
    }

	render(){
		const { style,barStyle,timerData } = this.props;
		const { timeLeftInPercentage } = this.state;
		if(isNumber(timeLeftInPercentage)){
			barStyle.width = `${timeLeftInPercentage}%`
		}
		return <div style={{...ContainerStyle,...style}}>
			<div style={{...SliderStyle,...barStyle}}/>
			{
				timerData && <Timer style={{marginTop: -10,marginLeft:-2}} timeLeft={parseInt(timerData.timeLeft)}/>
			}
		</div>
	}
}

ProgressBar.defaultProps = {
    endDate:0,
    style:{},
    barStyle:{},
};

ProgressBar.propTypes = {
	timerData:PropTypes.object,
	style:PropTypes.object,
	barStyle:PropTypes.object,
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/ProgressBar.js